export default {
  default_browser_tag: 'FoodAmigos - Pide online',
  seo: {
    title: '{{name}} - pide comida online en {{city}}',
    description: '{{name}} en {{city}}. Menú oficial. Ahorra dinero y pide online.',
  },
};
